import { usePrevious } from './usePrevious'

export const useCompareToPrev = val => {
  const prevVal = usePrevious(val)
  return prevVal !== val
}
